import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
  root: {
    height: '100%',
    padding: '32px 168px',
    position: 'relative',
  },
  header: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px',
  },
  headerTitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
  },
  bottomContainer: {
    position: 'absolute',
    bottom: 0,
    left: '50%',
    transform: 'translateX(-50%)',
  },
  unsubscribe: {
    marginLeft: 10,
  },
  userContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
}));
